import {makeStyles} from "@material-ui/styles";
import {createStyles, Theme} from "@material-ui/core";

const pausedStatusColors = {
    chip: '#FCF2C5',
    chipText: '#7A5C00',
    row: '#FEFAE6',
    rowHover: '#FCF2C5',
};

export const usePatientsListTableItemStyle = makeStyles((theme: Theme) => createStyles({
    statusChip: {
        display: 'inline-block',
        padding: '3px 12px',
        borderRadius: '12px',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
    },
    rowPaused: {
        backgroundColor: pausedStatusColors.row,
        '&&:hover': {
            backgroundColor: pausedStatusColors.rowHover,
        },
    },
    statusChipPaused: {
        backgroundColor: pausedStatusColors.chip,
        color: pausedStatusColors.chipText,
    },
}));
